export class ProductRole {
    constructor(public data: {
        Id?: Number,
        ProductType?: Number,
        ProductRoleID?: Number,
        AllowMultipleClients?: Boolean,
        MaxClientsPerRole?: Number
    }) { }
}